module.exports = __webpack_public_path__ + "7d39ae2fdfa58eaade19d24c6510fff1.png";